export const PATH = {
    HOME: '/home',
    LOGIN: '/',
    JOB: '/job',
    EMPLOYEE: '/employee',
    JOBDETAILINFO: '/jobdetail',
    ADMIN: '/admin',
    VOUCHERS: '/vouchers',
    PAYMENT: '/payment',
    JOBCHARGE: '/job-charges',
    ROLES: '/roles',
    PERMISSIONS: '/permissions',
    ROLEPERMISSIONS: '/role-permissions',
    TASK: '/tasks',
    TASKPROGRESSNOTE: '/tasks-progress-note',
};
